import { Box, Group, NumberInput, Text } from '@mantine/core';
import { FieldValues, useController } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { FormControlInput } from '@/core/components';

export interface PublishedAtControlProps<T extends FieldValues> extends FormControlInput<T> {
  withAsterisk?: boolean;

  label: string;
  description?: string;

  isDisabled?: boolean;
}

export function PublishedAtControl<T extends FieldValues>(props: PublishedAtControlProps<T>) {
  const { withAsterisk, label, description, name, isSubmitting, isDisabled, control } = props;

  const {
    field: monthField,
    fieldState: { error: monthError },
    // @ts-expect-error fix in the future
  } = useController({ name: `${name}.month`, control });

  const {
    field: yearField,
    fieldState: { error: yearError },
    // @ts-expect-error fix in the future
  } = useController({ name: `${name}.year`, control });
  const { t } = useTranslation();

  return (
    <Box flex={1}>
      <Text fw="500">{label}</Text>
      {description && (
        <Text
          size="sm"
          c="dimmed"
        >
          {description}
        </Text>
      )}
      <Group mt="3px">
        <NumberInput
          ref={monthField.ref}
          name={monthField.name}
          value={monthField.value == null ? '' : String(monthField.value)}
          onChange={newNo => monthField.onChange(newNo == '' ? null : Number(newNo))}
          label={t('publishedAt.month')}
          placeholder={t('publishedAt.month')}
          error={monthError?.message}
          disabled={isSubmitting || isDisabled}
          flex={1}
        />
        <NumberInput
          ref={yearField.ref}
          name={yearField.name}
          value={yearField.value == null ? '' : String(yearField.value)}
          onChange={newNo => yearField.onChange(newNo == '' ? null : Number(newNo))}
          label={t('publishedAt.year')}
          placeholder={t('publishedAt.year')}
          withAsterisk={withAsterisk}
          error={yearError?.message}
          disabled={isSubmitting || isDisabled}
          flex={1}
        />
      </Group>
    </Box>
  );
}
